
<router-outlet>
    <app-layout-register-client></app-layout-register-client>
</router-outlet>
<ngx-spinner bdColer="rgb(51, 51, 51 ,0.8)" size="large" color="#fff" [fullSreen]="true" type="ball-circus">
</ngx-spinner>


